export enum PurchaseStatus {
  Lost = 'lost',
  Pending = 'pending',
  Won = 'won',
}
